import isArray from 'lodash/isArray';

import getFilterWithCol from '../../helpers/getFilterWithCol';

export const filterSearch = ['FilterField', {
  id: 'search',
  label: null, // 'ID',
  section: 'top',
  col: 12,
  buildQuery: (value, builder) => value && builder.add(
    'where',
    { name: { REGEX: value, OPTIONS: 'i' } },
  ),
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
    ? undefined
    : value.target
    ? value.target.value
    : value;
    return !value || !value.length
    ? undefined
    : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Search referral name',
  }],
}];

export const filterStore = ['FilterField', {
  id: 'store',
  label: null,
  section: 'top',
  col: 12,
  propsFromPage: props => ({ client: props.client }),
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    { store: { IN: isArray(value) ? value : [value] } },
  ),
  getValueForField: value => (
    value && value.length
    ? value
    : undefined
  ),
  field: ['FieldConnectionSelect', {
    name: 'store',
    url: '/stores/list',
    placeholder: 'Find By Store',
    mode: 'multiple',
    allowClear: true,
    searchPaths: ['name'],
  }],
}];

export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const filterPopulateStore = ['FilterHidden', {
  id: 'populateStore',
  build: builder => builder.add('populate', { store: { name: true } }),
}];

export const filterPopulateReferralStore = ['FilterHidden', {
  id: 'populateReferralStore',
  build: builder => builder.add('populate', { referralStore: true }),
}];

export const ADMIN = [
  ...[
    [filterSearch, 12],
    [filterStore, 12],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),

  filterPagination,
  filterPopulateStore,
  filterPopulateReferralStore,
];

export const SELLER_MERCHANT = [
  ...[
    [filterSearch, 12],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),

  filterPagination,
  filterPopulateReferralStore,
];

export const SELLER_REFERRAL = [
  ...[
    [filterSearch, 12],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),

  filterPagination,
  filterPopulateStore,
];
